import React from 'react';
import ReactDOM from 'react-dom';

import { connect } from 'react-redux';

import Artwork from '../FullScreenCarouselItem';
import SelectedPlaylistCarousel from '../SelectedPlaylistCarousel';

import SoundCloudPlayer from '../SoundCloudPlayer';
import SoundCloudButton from '../SoundCloudButton';

import './freemium-full-screen-carousel.scss';
import { setQualityFlag, setMuteFlag, fireAnalytics } from '../../pages/utils.js';
import { fetchActivePlaylist } from '../../store/actions/playlistActions';
import { fetchMobileQueue, fetchMobileStatus } from '../../store/actions/mobileActions';
import { pauseSoundCloudStream, resumeSoundCloudStream } from '../../store/actions/soundCloudActions';
import { ENTER, BACK, LEFT, UP, RIGHT, DOWN, EXIT } from '../../util/remoteButtons';

export class FreemiumCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: props.selectedArtwork,
      navTimeout: null,
      navigating: false,
      showNav: false,
      nxtLoad: false,
      others: false,
      artworks: props.artworks,
      show: true,
      activeComponent: false,
      currentPlaylist: 0,
      selectedPlaylistId: props.selectedPlaylistId,
      selectedPlaylist: null,
      open: false,
      lastMobileUpdate: null,
      selectedButton: 'view',
      artworkError: false,
      clearCache: false,
    };

    this.fsTimeout = null;
    this.getCurrentArtworkArtistName = this.getCurrentArtworkArtistName.bind(this);
    this.getCurrentArtworkName = this.getCurrentArtworkName.bind(this);
    this.handleConnectionChange = this.handleConnectionChange.bind(this);
    this.setArtworkInterval = this.setArtworkInterval.bind(this);
    this.addOrientationClassToBody = this.addOrientationClassToBody.bind(this);
    this.addOrientationClassToPlaylistCarousel = this.addOrientationClassToPlaylistCarousel.bind(this);
    // this.FileExists = this.FileExists.bind(this);
    this.k = 1;
    this.artworkInterval = 300000;
    this.updatePlaylist = true;
    this.mergeMyPlaylist = this.mergeMyPlaylist.bind(this);
    this.hideArtworkNameTimeout = null;
    this.selectedBtn = 'No';
    this.onlineStatusInterval = null;
    this.artworkIntervalTime = null;
    this.artworkErrorMessage = '';
    this.onlineStatusTimer = 0;
    this.prevPlaylistId = '';
    this.fetchMobilePlaylistInterval = null;
  }

  componentDidMount() {
    fireAnalytics('Page', 'Player Page Loaded');
    window.onkeydown = (e) => {
      if (navigator.onLine) {
        if (this.state.navigating) {
          switch (e.keyCode) {
            case ENTER: {
              if (this.state.open) {
                if (this.selectedBtn === 'No') {
                  this.setState({ open: false });
                  setTimeout(() => {
                    const { mainDiv } = this.refs;
                    mainDiv.focus();
                  }, 700);
                }
                if (this.selectedBtn === 'Yes') {
                  window.open('', '_self').close();
                }
              } else if (this.state.clearCache) {
                if (this.selectedBtn === 'No') {
                  this.setState({ clearCache: false });
                  setTimeout(() => {
                    const { mainDiv } = this.refs;
                    mainDiv.focus();
                  }, 700);
                }
                if (this.selectedBtn === 'Yes') {
                  // window.open("", "_self").close();
                  // this.props.history.push('/');
                  this.removeAllDownloads();
                }
              } else {
                switch (this.state.selectedButton) {
                  case 'account': {
                    this.props.history.push('/Account');
                    break;
                  }
                  case 'upgrade': {
                    localStorage.setItem('playlistID', '9363149b-09a6-48c6-a1d0-6ba28bfd4e7a');
                    this.props.history.push('/Pair');
                    break;
                  }
                  default:
                    this.setState((prevState) => ({ ...prevState, navigating: false, navTimeout: null }));
                    break;
                }
              }
              break;
            }
            case LEFT: {
              if (this.state.open || this.state.clearCache) {
                document.getElementById('yes').style.background = '';
                document.getElementById('No').style.background = '#910048';
                this.refs.no.focus();
                this.selectedBtn = 'No';
              } else {
                clearTimeout(this.state.navTimeout);
                if (!this.state.activeComponent) {
                  this.prevHandle();
                  clearInterval(this.artworkIntervalTime);
                  this.setArtworkInterval(this.artworkInterval);
                }
              }

              break;
            }
            case RIGHT: {
              if (this.state.open || this.state.clearCache) {
                document.getElementById('No').style.background = '';
                document.getElementById('yes').style.background = '#910048';
                this.refs.yes.focus();
                this.selectedBtn = 'Yes';
              } else {
                clearTimeout(this.state.navTimeout);
                if (!this.state.activeComponent) {
                  this.nextHandle();
                  clearInterval(this.artworkIntervalTime);
                  this.setArtworkInterval(this.artworkInterval);
                }
              }
              break;
            }
            case UP: {
              if (!this.state.open) {
                clearTimeout(this.state.navTimeout);
                const navTimeout = setTimeout(() => {
                  this.setState((prevState) => ({ ...prevState, navigating: false }));
                }, 4000);

                if (this.props.hasSubscription) {
                  this.setState((prevState) => ({ ...prevState, selectedButton: 'account', navTimeout }));
                  setTimeout(() => {
                    const { accountButton } = this.refs;
                    accountButton.focus();
                  }, 300);
                } else {
                  this.setState((prevState) => ({ ...prevState, selectedButton: 'upgrade', navTimeout }));
                  setTimeout(() => {
                    const { upgrade } = this.refs;
                    upgrade.focus();
                  }, 300);
                }
                break;
              }
            }
            case 27:
              this.setState({ clearCache: !this.state.clearCache });
              break;
            case BACK: {
              setTimeout(() => {
                const { no } = this.refs;
                no.focus();
              }, 200);
              this.setState({ open: !this.state.open });
              break;
            }
            default:
              break;
          }
        } else if ((e.keyCode === LEFT || e.keyCode === RIGHT || e.keyCode === UP) && !this.state.activeComponent) {
          if (this.state.open && e.keyCode === LEFT) {
            document.getElementById('yes').style.background = '';
            document.getElementById('No').style.background = '#910048';
            this.refs.no.focus();
            this.selectedBtn = 'No';
          } else if (this.state.open && e.keyCode === RIGHT) {
            document.getElementById('No').style.background = '';
            document.getElementById('yes').style.background = '#910048';
            this.refs.yes.focus();
            this.selectedBtn = 'Yes';
          } else {
            clearTimeout(this.state.navTimeout);
            const navTimeout = setTimeout(() => {
              this.setState((prevState) => ({ ...prevState, navigating: false }));
            }, 4000);
            this.setState((prevState) => ({ ...prevState, navigating: true, navTimeout }));
          }
        } else if (e.keyCode === DOWN) {
          if (!this.state.open) {
            if (this.state.activeComponent) {
              this.setState(() => ({ activeComponent: false }));
            } else {
              this.setState(() => ({ activeComponent: true }));
              this.addOrientationClassToPlaylistCarousel();
              setTimeout(() => {
                const { playlistChild } = this.refs;
                playlistChild.refs.carousel.focus();
              }, 300);
            }
          }
        } else if (e.keyCode === BACK) {
          if (this.state.activeComponent) {
            this.setState(() => ({ activeComponent: false }));
          } else {
            setTimeout(() => {
              this.setState({ open: !this.state.open });
              const { no } = this.refs;
              no.focus();
            }, 700);
          }
        } else if (e.keyCode === 405) {
          setTimeout(() => {
            const { no } = this.refs;
            no.focus();
          }, 200);
          this.setState({ clearCache: !this.state.clearCache });
        } else if (e.keyCode === ENTER) {
          if (this.state.open) {
            if (this.selectedBtn === 'No') {
              this.setState({ open: false });
              setTimeout(() => {
                const { mainDiv } = this.refs;
                mainDiv.focus();
              }, 700);
            }
            if (this.selectedBtn === 'Yes') {
              window.open('', '_self').close();
            }
          } else if (this.state.clearCache) {
            if (this.selectedBtn === 'No') {
              this.setState({ clearCache: false });
              setTimeout(() => {
                const { mainDiv } = this.refs;
                mainDiv.focus();
              }, 700);
            }
            if (this.selectedBtn === 'Yes') {
              // window.open("", "_self").close();
              // this.props.history.push('/');
              this.removeAllDownloads();
            }
          }
        }
      } else {
        this.artworkErrorMessage = 'No Internet Connection';
        this.setState({ artworkError: true });
        setTimeout(() => {
          this.setState({ artworkError: false });
        }, 3000);
      }
    };
    // this.onlineStatusInterval = setInterval(() => this.updateOnlineStatus(), 7000);
    this.addOrientationClassToBody();
    if (this.props.hasSubscription) {
      this.fetchMobilePlaylistInterval = setInterval(() => this.FetchFromMobile(), 5000);
      this.mergeMyPlaylist();
    } else {
      this.fetchMobilePlaylistInterval = 10;
      this.setArtworkInterval(this.artworkInterval);
    }
    window.addEventListener('online', this.handleConnectionChange);
    window.addEventListener('offline', this.handleConnectionChange);
    // document.getElementById("userAgent").innerHTML = navigator.userAgent;
    // document.getElementById("deviceDetails").innerHTML = "Screen Resolution : " + window.screen.width * window.devicePixelRatio + "x" + window.screen.height * window.devicePixelRatio + "Device : " + window.screen.availWidth + "x" + window.screen.availHeight + "   Pixel Ratio : " + window.devicePixelRatio + "     Pixel Ratio With Ceil : " + Math.ceil(window.devicePixelRatio);
  }

  removeAllDownloads() {
    const that = this;
    const successCb = function (cbObject) {
      console.log('Removed all files ');
      that.setState({ clearCache: false });
      that.props.history.push('/');
    };

    const failureCb = function (cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;
      console.log(` Error Code [${errorCode}]: ${errorText}`);
    };

    const options = {
      device: 'internal', // This will remove all the files in the local storage.
    };

    const storage = new Storage();
    storage.removeAll(successCb, failureCb, options);
  }

  addOrientationClassToBody() {
    if (window.innerWidth <= window.innerHeight) {
      // const v = document.getElementsByTagName('video');
      // const poster = document.getElementById('poster');
      // v[0].classList.add("VideoRotated");
      // poster.classList.add("VideoRotated");
      if (document.getElementsByClassName('PlaylistSelector')[0] !== undefined) {
        document.getElementsByClassName('PlaylistSelector')[0].classList.add('PlaylistSelector_Rotated');
      }
    }
  }

  addOrientationClassToPlaylistCarousel() {
    if (window.innerWidth <= window.innerHeight) {
      if (document.getElementsByClassName('PlaylistSelector')[0] !== undefined) {
        document.getElementsByClassName('PlaylistSelector')[0].classList.add('PlaylistSelector_Rotated');
      }
    }
  }

  handleConnectionChange(event) {
    if (event.type == 'offline') {
      console.log('You lost connection.');
      fireAnalytics('Network', 'Connection Offline');
      clearInterval(this.artworkIntervalTime);
      clearInterval(this.fetchMobilePlaylistInterval);
      this.artworkErrorMessage = 'No Internet Connection';
      this.setState({ artworkError: true });
      setTimeout(() => {
        this.setState({ artworkError: false });
      }, 3000);
    }
    if (event.type == 'online') {
      console.log('You are Online.');
      fireAnalytics('Network', 'Connection Online');
      if (this.props.hasSubscription) {
        this.setArtworkInterval(this.artworkInterval);
        this.fetchMobilePlaylistInterval = setInterval(() => this.FetchFromMobile(), 5000);
      } else {
        this.setArtworkInterval(this.artworkInterval);
      }
      this.artworkErrorMessage = 'Connection Online';
      this.setState({ artworkError: true });
      setTimeout(() => {
        this.setState({ artworkError: false });
      }, 3000);
    }
  }

  mergeMyPlaylist() {
    const { length } = this.props.myPlaylist.data;

    if (length > 0) {
      for (let i = 0; i < length; i++) {
        if (this.props.myPlaylist.data[i].artwork.length > 0) {
          this.props.homePlaylist.data.push(this.props.myPlaylist.data[i]);
        }
      }
    }
  }

  setArtworkInterval(interval) {
    if (interval === 0) {
      this.artworkInterval = interval;
      clearInterval(this.artworkIntervalTime);
    } else {
      clearInterval(this.artworkIntervalTime);
      this.artworkInterval = interval;
      this.artworkIntervalTime = setInterval(() => {
        this.k = 1;
        setTimeout(() => {
          this.nextHandle();
        }, 800);
      }, this.artworkInterval);
    }
  }

  async FetchFromMobile() {
    try {
      if (this.props.hasSubscription) {
        const status = await this.props.fetchMobileStatus(this.props.device.data.uid);

        if (this.state.lastMobileUpdate === null) {
          this.setState({ lastMobileUpdate: status.payload.queueUpdatedAt });
        }

        if (
          status.type === 'FETCH_MOBILE_STATUS_SUCCESS' &&
          status.payload.queueUpdatedAt !== this.state.lastMobileUpdate
        ) {
          this.setState({ lastMobileUpdate: status.payload.queueUpdatedAt });
          const result = await this.props.fetchMobileQueue(this.props.device.data.uid);

          if (result.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          if (result.errors === 'Device Unregistered') {
            this.props.history.push('/');
            return;
          }

          if (this.props.app.mobileId.localeCompare(status.payload.userId) !== 0) {
            this.props.history.push('/');
            return;
          }

          setMuteFlag(status.payload.mute);
          if (result.type === 'FETCH_MOBILE_QUEUE_SUCCESS') {
            // if (this.state.lastMobileUpdate === null) {
            //   this.setState({ lastMobileUpdate: result.payload.updatedAt });
            //   return;
            // }
            if (this.artworkInterval !== this.props.device.data.interval) {
              this.setArtworkInterval(this.props.device.data.interval);
            }

            // if (result.payload.updatedAt !== this.state.lastMobileUpdate) {
            //   this.setState({ lastMobileUpdate: result.payload.updatedAt });
            //   if (Object.keys(result.payload.queue).length <= 0) {
            //     return;
            //   }
            if (result.payload.collection.artwork.length <= 0) {
              this.artworkErrorMessage = 'Unable to play the Selected Artwork.';
              this.setState({ artworkError: true });
              setTimeout(() => {
                this.setState({ artworkError: false });
              }, 3000);
              return;
            }
            this.setState({
              artworks: result.payload.collection.artwork,
              current: 0,
            });
            this.setState({ activeComponent: false });
            clearInterval(this.artworkIntervalTime);
            this.artworkInterval = null;
            this.updatePlaylist = false;
            const activePlaylist = this.props.fetchActivePlaylist(result.payload.collection.id);
            if (activePlaylist.errors === 'Error') {
              setTimeout(() => {
                this.props.history.push('/error');
              }, 10);
              return;
            }
            fireAnalytics('Playlist', 'Playlist Received From Mobile', result.payload.collection.id);
          }
          // }
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getArtworkFromPlaylist(id) {
    if (this.props.hasSubscription) {
      const activePlaylist = await this.props.fetchActivePlaylist(id);
      if (activePlaylist.errors === 'No Artworks') {
        this.artworkErrorMessage = 'No artworks in Collection';
        this.setState({ activeComponent: false, artworkError: true });
        setTimeout(() => {
          this.setState({ artworkError: false });
        }, 4000);
        await this.props.fetchActivePlaylist(this.prevPlaylistId);
      } else if (activePlaylist.errors === 'Error') {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      } else {
        this.updatePlaylist = true;
        // this.addIdIntoDB(id);
      }
      fireAnalytics('Playlist', 'Playlist Changed', id);
    } else {
      localStorage.setItem('playlistID', id);
      this.props.history.push('/Pair');
    }
  }

  async addIdIntoDB(id) {
    let db;
    db = await idb.openDb('playlistIdDb', 1, (db) => {
      db.createObjectStore('playlistId', { keyPath: 'id' });
    });
    const tx = db.transaction('playlistId', 'readwrite');

    try {
      await tx.objectStore('playlistId').clear();
      await tx.objectStore('playlistId').add({ id });
    } catch (err) {
      if (err.name == 'ConstraintError') {
        alert('Such book exists already');
      } else {
        throw err;
      }
    }
  }

  async setCurrent(pid) {
    this.props.homePlaylist.data.filter((data, idx) => {
      if (data.playlistId === pid) {
        this.setState({ currentPlaylist: idx });
      }
    });
  }

  async setExitApp() {
    this.setState({ activeComponent: false });
  }

  prevHandle() {
    clearInterval(this.artworkIntervalTime);
    if (this.props.hasSubscription) {
      console.log(this.props.mobileQueue);
      this.setArtworkInterval(this.props.mobileQueue.data.interval);
    } else {
      this.setArtworkInterval(this.artworkInterval);
    }
    clearTimeout(this.state.navTimeout);
    const slides = this.state.artworks.slice(0);
    slides.unshift(slides.pop());

    const navTimeout = setTimeout(() => {
      this.setState((prevState) => ({ ...prevState, navigating: false }));
    }, 4000);

    this.setState((prevState) => ({
      ...prevState,
      navTimeout,
      artworks: slides,
    }));
  }

  nextHandle() {
    clearInterval(this.artworkIntervalTime);
    if (this.props.hasSubscription) {
      console.log(this.props.mobileQueue);
      this.setArtworkInterval(this.props.mobileQueue.data.interval);
    } else {
      this.setArtworkInterval(this.artworkInterval);
    }
    clearTimeout(this.state.navTimeout);
    const newArray = this.state.artworks.slice(0);
    newArray.push(newArray.shift());
    const navTimeout = setTimeout(() => {
      this.setState((prevState) => ({ ...prevState, navigating: false }));
    }, 4000);
    this.setState((prevState) => ({ ...prevState, navTimeout, artworks: newArray }));
  }

  getCurrentArtworkName() {
    const { artworks } = this.state;
    if (!artworks || artworks.length == 0) return '';

    return artworks[this.state.current].name;
  }

  getCurrentArtworkArtistName() {
    const { artworks } = this.state;
    if (!artworks || artworks.length == 0) return '';

    const { current } = this.state;
    return artworks[current].artist.displayName;
    // return `${artworks[current]._embedded.artist.givenName} ${artworks[current]._embedded.artist.surname}`;
  }

  componentWillUnmount() {
    clearInterval(this.fetchMobilePlaylistInterval);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedPlaylistId !== this.state.selectedPlaylistId && this.updatePlaylist) {
      this.prevPlaylistId = nextProps.selectedPlaylistId;
      const { artworks } = nextProps;
      this.setState({
        artworks,
        current: 0,
        selectedPlaylistId: nextProps.selectedPlaylistId,
      });
      clearInterval(this.artworkIntervalTime);
      this.setArtworkInterval(this.props.mobileQueue.data.interval);
      this.setState({ activeComponent: false });
    }
  }

  handleSoundCloudButtonClick(event) {
    if (event.keyCode === 13) {
      if (this.props.soundCloud.isStreaming) {
        this.props.pauseSoundCloudStream();
      } else {
        this.props.resumeSoundCloudStream();
      }
    }
    if (event.keyCode === 39 || event.keyCode === 37) {
      this.refs.home.focus();
    }
    if (event.keyCode === 40) {
      this.refs.previous.focus();
    }
  }

  render() {
    const { current, showNav, artworks } = this.state;
    const slideWidth = 100;
    let left = -current * slideWidth - 100;

    const slides = artworks.map((item, idx) => {
      left += slideWidth;
      if (idx === current) {
        return (
          <div key={idx} className="freemium-full-screen-carousel__slide" style={{ left: `${left}%` }}>
            <Artwork
              isCurrent={idx == current}
              artwork={item}
              hasSubscription={this.props.hasSubscription}
              history={this.props.history}
            />
          </div>
        );
      }
    });

    return (
      <div
        className="fullscreenFreemiumWrapper"
        ref="mainDiv"
        onClick={() => {
          if (this.state.navigating) {
            this.setState(() => ({ activeComponent: true, navigating: false }));
            this.addOrientationClassToPlaylistCarousel();
            setTimeout(() => {
              const { playlistChild } = this.refs;
              playlistChild.refs.carousel.focus();
            }, 300);
          } else if (this.state.activeComponent) {
            this.setState(() => ({ activeComponent: false }));
          } else {
            clearTimeout(this.state.navTimeout);
            const navTimeout = setTimeout(() => {
              this.setState((prevState) => ({ ...prevState, navigating: false }));
            }, 4000);
            this.setState((prevState) => ({ ...prevState, navigating: true, navTimeout }));
          }
        }}
      >
        {slides}
        {this.state.open ? (
          <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999' }}>
            <div
              className="model"
              style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}
            >
              <img
                className="Logo2"
                src="assets/img/blackdove-logo-2020.png"
                alt=""
                style={{ width: '50%', paddingTop: '6%' }}
              />
              <h2 style={{ marginBottom: '2%' }}>Do you want to exit?</h2>
              <button
                ref="no"
                id="No"
                style={{
                  padding: '2%',
                  float: 'left',
                  width: '30%',
                  fontSize: '2em',
                  marginBottom: '6%',
                  marginLeft: '14%',
                  marginTop: '4%',
                  fontWeight: '600',
                  background: '#910048',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ open: false, selectedBtn: 'No' });
                  setTimeout(() => {
                    const { mainDiv } = this.refs;
                    mainDiv.focus();
                  }, 700);
                }}
              >
                No
              </button>
              <button
                ref="yes"
                id="yes"
                style={{
                  padding: '2%',
                  float: 'right',
                  width: '30%',
                  fontSize: '2em',
                  marginBottom: '6%',
                  marginRight: '18%',
                  marginTop: '4%',
                  fontWeight: '600',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({
                    selectedBtn: 'Yes',
                  });
                  window.open('', '_self').close();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        ) : null}
        {this.state.clearCache ? (
          <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999' }}>
            <div
              className="model"
              style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}
            >
              <img
                className="Logo2"
                src="assets/img/blackdove-logo-2020.png"
                alt=""
                style={{ width: '50%', paddingTop: '6%' }}
              />
              <h2 style={{ marginBottom: '2%', fontSize: '2em', padding: '0 1em' }}>
                Do you want to clear device cache and reload app?
              </h2>
              <button
                ref="no"
                id="No"
                style={{
                  padding: '2%',
                  float: 'left',
                  width: '30%',
                  fontSize: '2em',
                  marginBottom: '6%',
                  marginLeft: '14%',
                  marginTop: '4%',
                  fontWeight: '600',
                  background: '#910048',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ clearCache: false, selectedBtn: 'No' });
                  setTimeout(() => {
                    const { mainDiv } = this.refs;
                    mainDiv.focus();
                  }, 700);
                }}
              >
                No
              </button>
              <button
                ref="yes"
                id="yes"
                style={{
                  padding: '2%',
                  float: 'right',
                  width: '30%',
                  fontSize: '2em',
                  marginBottom: '6%',
                  marginRight: '18%',
                  marginTop: '4%',
                  fontWeight: '600',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({
                    selectedBtn: 'Yes',
                  });
                  this.removeAllDownloads();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        ) : null}
        {this.state.navigating && (
          <div className="fullscreenNavOverlay">
            {this.props.hasSubscription && (
              <div
                ref="accountButton"
                tabIndex="1"
                className="btn btn--round btn--dark btn--fill accountBtn"
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({
                    selectedButton: 'account',
                  });
                  this.props.history.push('/Account');
                }}
              >
                {' '}
                Account
              </div>
            )}
            {/* {
                <SoundCloudButton
                  style={{ right: this.props.hasSubscription ? '100px' : '280px', position: 'absolute', top: '60px' }}
                  onKeyDown={(e) => { this.handleSoundCloudButtonClick(e) }}
                  ref="soundCloudButton"
                />
              } */}
            {!this.props.hasSubscription && (
              <div
                ref="upgrade"
                tabIndex="1"
                className="btn btn--round btn--dark btn--fill pairBtn"
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({
                    selectedButton: 'upgrade',
                  });
                  localStorage.setItem('playlistID', '9363149b-09a6-48c6-a1d0-6ba28bfd4e7a');
                  this.props.history.push('/Pair');
                }}
              >
                Pair QR Code
              </div>
            )}
            <div
              onClick={(e) => {
                e.stopPropagation();
                this.prevHandle();
              }}
              className="btn btn--circle navLeft"
            >
              <span tabIndex="2" ref="previous" className="ion-ios-arrow-back btn--arrow" />
            </div>
            <div style={{ textAlign: 'center' }}>
              <h2 className="h--no-spacing" style={{ color: 'white', textTransform: 'uppercase' }}>
                {this.getCurrentArtworkName()}
              </h2>
              <h5 className="h--normalize-weight" style={{ color: 'white' }}>
                {this.getCurrentArtworkArtistName()}
              </h5>
            </div>
            <div
              onClick={(e) => {
                e.stopPropagation();
                this.nextHandle();
                this.k = 1;
              }}
              className="btn btn--circle navRight"
            >
              <span ref="next" tabIndex="3" className="ion-ios-arrow-forward btn--arrow" />
            </div>
          </div>
        )}
        <div className="artworkError" style={!this.state.artworkError ? { opacity: '0' } : { opacity: '1' }}>
          {this.artworkErrorMessage}
        </div>
        <div className="userAgent" id="userAgent" />
        <div className="deviceDetails" id="deviceDetails" />
        <div className="PlaylistSelector" style={this.state.activeComponent ? { bottom: '0%' } : { bottom: '-36%' }}>
          <SelectedPlaylistCarousel
            ref="playlistChild"
            playlist={this.props.homePlaylist.data}
            currentPlaylist={this.state.currentPlaylist}
            subscription={this.props.hasSubscription}
            history={this.props.history}
            dispatch={this.props.dispatch}
            getArtworkFromPlaylist={(pid) => this.getArtworkFromPlaylist(pid)}
            setCurrent={(pid) => this.setCurrent(pid)}
            onExitApp={() => this.setExitApp()}
          />
        </div>
        <SoundCloudPlayer />
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
  fetchMobileQueue: (deviceId) => dispatch(fetchMobileQueue(deviceId)),
  pauseSoundCloudStream: () => dispatch(pauseSoundCloudStream()),
  resumeSoundCloudStream: () => dispatch(resumeSoundCloudStream()),
  fetchMobileStatus: (deviceId) => dispatch(fetchMobileStatus(deviceId)),
});

export default connect((state) => {
  const { homePlaylist, userPlaylists, myPlaylist, device, mobileQueue, soundCloud, app } = state;
  return {
    app,
    userPlaylists,
    homePlaylist,
    myPlaylist,
    device,
    mobileQueue,
    soundCloud,
  };
}, mapDispatchToProps)(FreemiumCarousel);
